import { gql } from '@apollo/client'

const DELETE_LEAD_STAGE = gql`
  mutation DELETE_LEAD_STAGE($leadStage: ID!, $mergeTo: ID!) {
    deleteLeadStage(leadStage: $leadStage, mergeTo: $mergeTo) {
      id
    }
  }
`

export default DELETE_LEAD_STAGE
